/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { WorkItem } from "../workers/types";

const fetchWorkItemsFromWorker = async (
  workerID: string,
  initialDate: Date,
) => {
  let params = {};

  if (initialDate) {
    const day = initialDate.getDate();
    const month = initialDate.getMonth();
    const year = initialDate.getFullYear();
    params = { day, month, year };
  }

  const { data } = await apiInputService.get(
    `/frontend/workItems/workerId/${workerID}`,
    {
      params: {
        ...params,
      },
    }
  );

  return data;
};

export const useWorkItemsFromWorker = (
  workerID: string,
  initialDate?: Date,
  consolidatedWorkerId?: string,
  options?: any
) => {
  return useQuery<WorkItem[]>(
    ["work-items-worker", workerID, initialDate?.toLocaleDateString(), consolidatedWorkerId],
    () => fetchWorkItemsFromWorker(workerID, initialDate),
    {
      enabled: Boolean(workerID),
      ...options,
    }
  );
};
